module.exports = __webpack_public_path__ + "img/1580189663.74c24c5c.jpg";